<div class="h-100">
    <div class="dashboard-window-header d-flex align-items-center">
        <h6 *ngIf="dashboard" class="font-size-20" style="font: normal normal normal 18px/24px Roboto; padding-left: 24px; margin-bottom: 0px;">
            {{dashboard?.dashboard.DashboardName}}
            <span class="color-valyrianSteel" cvLocalizedText langSection="Dashboard_Window" langKey="Read_Only">Read Only</span>
        </h6>
    </div>
    <div *ngIf="dashboardReady" style="margin-top: 6px;">
        <cv-responsive-dashboard *ngIf="dashboard?.dashboard.DashboardKey != null && hasAccess" class="responsiveDashboard" [dashboardInfo]="dashboard.dashboard"></cv-responsive-dashboard>
        <div *ngIf="!hasAccess" class="dashboard-window-grid-text h-100 d-flex" cvLocalizedText langSection="Dashboard_Window" langKey="No_Access">You do not have access to this dashboard.</div>
    </div>
</div>
